import { useLocation } from 'react-router-dom';
import { useStudiosCatalogSearch } from '@/contexts/StudiosCatalogSearchContext';
import { NavbarSearchPopoverControl } from '@/components/Layout/NavbarSearchPopoverControl';

export function StudiosSearchNavbarControl() {
  const location = useLocation();
  const isStudiosRoute = location.pathname === '/studios';
  const { searchInput, setSearchInput, clearSearch } = useStudiosCatalogSearch();

  if (!isStudiosRoute) return null;

  return (
    <NavbarSearchPopoverControl
      value={searchInput}
      onChange={setSearchInput}
      onClear={clearSearch}
      placeholder="Поиск по студиям..."
      ariaLabel="Поиск по таблице студий"
      dialogTitle="Поиск по студиям"
    />
  );
}
